import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../redux/userSlice';
import { useNavigate } from 'react-router-dom';
import { HiOutlineMenu, HiOutlineX } from 'react-icons/hi';

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(clearUser());
    navigate('/');
  };

  const handleGetStarted = () => {
    navigate('/login');
  };

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  const navLinks = ['Features', 'How It Works', 'Privacy', 'FAQ'];

  return (
    <header className='fixed top-0 left-0 w-full z-50 bg-black/80 backdrop-blur-md border-b border-white/10'>
      <div className='container mx-auto flex justify-between items-center h-20 px-6'>
        {/* Logo */}
        <div
          className='text-xl md:text-2xl font-bold text-white tracking-wide cursor-pointer hover:opacity-80 transition-opacity'
          onClick={() => navigate('/')}
        >
          <span>
            Autonomous Reviews
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className='hidden md:flex items-center space-x-8'>
          {navLinks.map((link) => (
            <a
              key={link}
              href={`#${link.toLowerCase().replace(/\s/g, '-')}`}
              className='text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wider'
            >
              {link}
            </a>
          ))}

          {isAuthenticated ? (
            <button
              onClick={handleLogout}
              className='px-6 py-2 rounded-full bg-white text-black font-bold hover:bg-gray-200 transition-colors'
            >
              Logout
            </button>
          ) : (
            <button
              onClick={handleGetStarted}
              className='px-6 py-2 rounded-full bg-white text-black font-bold hover:bg-gray-200 transition-colors shadow-[0_0_15px_rgba(255,255,255,0.2)]'
            >
              Get Started
            </button>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <div className='md:hidden flex items-center'>
          <button
            onClick={toggleMobileMenu}
            className='text-white text-2xl focus:outline-none'
          >
            {isMobileMenuOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isMobileMenuOpen && (
        <div className='md:hidden bg-black border-t border-white/10'>
          <ul className='flex flex-col items-center space-y-6 py-8'>
            {navLinks.map((link) => (
              <li key={link}>
                <a
                  href={`#${link.toLowerCase().replace(/\s/g, '-')}`}
                  className='text-gray-300 text-lg hover:text-white transition uppercase tracking-wide'
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link}
                </a>
              </li>
            ))}
            <li>
              {isAuthenticated ? (
                <button
                  onClick={handleLogout}
                  className='bg-white text-black px-8 py-3 rounded-full font-bold shadow-md hover:scale-105 transition-transform'
                >
                  Logout
                </button>
              ) : (
                <button
                  onClick={handleGetStarted}
                  className='bg-white text-black px-8 py-3 rounded-full font-bold hover:scale-105 transition-transform shadow-md'
                >
                  Get Started
                </button>
              )}
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
